import { app_login_registration_RowClass } from '../../dbschema/index';
import {BaseContainerModel} from '../base-container.model';

export class AppLoginRegistrationContainerModel extends BaseContainerModel{
    app_login_registration: app_login_registration_RowClass = new app_login_registration_RowClass()
}